import ModuleContent from 'features/shared/layout/content/ModuleContent';
import Header from 'features/shared/layout/header/Header';
import React from 'react'
import { useTranslation } from 'react-i18next';
import EconomicalTariffSection from './sections/EconomicalTariffSection';

type Props = {}

const EconomicalTariff = (props: Props) => {
  const { t } = useTranslation("shared\\moduleNames");

  return (
    <>
      <Header title={t("economicalTariff.title")} includeBreadcrumbs />
      <ModuleContent>
        <EconomicalTariffSection />
      </ModuleContent>
    </>
  )
}

export default EconomicalTariff;